//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VueClazyLoad } from 'vue-clazy-load'
import { CapacitorUpdater } from '@capgo/capacitor-updater'
import { marked } from 'marked'
const format = require('string-template');

export default {
    components: {
    VueClazyLoad
  },
  data() {
    return {
      showFooterText: false,
      current: null,
      version: null
    }
  },
  computed: {
    seoFooter() {
        return _.get(this.$store.state.seo, 'meta.footer');
    },
    showTrustpilotWidget() {
      let businessUnitId = _.get(this.general, 'trustpilot_info.business_unit_id', '');
      let templateId = _.get(this.general, 'trustpilot_info.template_id', '');
      let _regex = /^([0-9A-Fa-f]{24})+$/
      return businessUnitId != null && templateId != null
          && businessUnitId.match(_regex) != null && templateId.match(_regex) != null;
    }
  },
  watch: {
    $route: function (value) {
      this.showFooterText = false
    },
    seoFooter: function (value) {
      if(value && value.length < 200) {
        this.showFooterText = true
      } else {
        this.showFooterText = false
      }
    }
  },
  async mounted() {
    window.CapacitorUpdater = CapacitorUpdater;
    try {
      this.current = await CapacitorUpdater.current()
      this.version = await CapacitorUpdater.versionName()
    }catch(e){}
  },
  methods: {
    isExternal(url) {
      return (_.startsWith(url, 'https://') || _.startsWith(url, 'http://'));
    },
    toggleFooterText() {
      this.showFooterText = !this.showFooterText
    },
    renderMd(string) {
      try {
        let variables = _.get(this.$store.state, 'seo.variables', {})
        string = format(string, variables)
        return marked.parse(string)
      } catch (e) {
        return ''
      }
    },
    openGlobalIframe(path) {
      // console.log('opne',path)
      this.loadGlobalIframe('open_page', {'url': path})
    },
    getUrl(url) {
      if(url.match(/^https?:\/\//i)) {
        return url
      } else {
        return this.localePath(_.trim(url))
      }
    }
  }
}
